//# sourceMappingURL=authentication.mjs.map
/// <reference types="./authentication.d.mts" />
import * as $auth from "../../../altar/altar/auth.mjs";
import * as $tab_bar from "../../../altar/altar/tab_bar.mjs";
import * as $invitation from "../../../data_types/data/auth/invitation.mjs";
import { Creation } from "../../../data_types/data/auth/invitation.mjs";
import * as $role from "../../../data_types/data/auth/role.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $user_effects from "../../admin/effects/user.mjs";
import * as $route from "../../data/route.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";
import * as $invite_users from "../../view/organization/authentication/invite_users.mjs";
import * as $list_users from "../../view/organization/authentication/list_users.mjs";

function tab(to, title) {
  let uri = new $route.Organization(new $route.Authentication(to));
  let uri$1 = $route.to_uri(uri);
  return $tab_bar.tab(uri$1, toList([$h.text(title)]));
}

function to_invitation(store, connection_id, user) {
  let invitee_email = user[0];
  let roles = user[1];
  let roles$1 = $list.map(roles, (r) => { return r.id; });
  let client_id = $auth.client_id();
  let organization = $store.current_organization(store);
  return $result.try$(
    $option.to_result(store.user, undefined),
    (user) => {
      return $result.try$(
        $option.to_result(user.email, undefined),
        (inviter_name) => {
          return $result.map(
            $option.to_result(organization, undefined),
            (organization) => {
              return new Creation(
                organization.id,
                inviter_name,
                invitee_email,
                client_id,
                connection_id,
                roles$1,
              );
            },
          );
        },
      );
    },
  );
}

function on_invite(users) {
  if (users instanceof Ok) {
    let connection_id = users[0].connection_id;
    let users$1 = users[0].users;
    return $effect.from_(
      (_, get_state, dispatch) => {
        let store = get_state();
        let _pipe = $list.filter_map(
          users$1,
          (_capture) => { return to_invitation(store, connection_id, _capture); },
        );
        let _pipe$1 = $user_effects.invite(_pipe);
        return dispatch(_pipe$1);
      },
    );
  } else {
    return $effect.none();
  }
}

function use_modal_click(component, next) {
  let dispatch = $store.use_effect_dispatch();
  let modal = $modal.use_modal();
  return ((_capture) => { return $redraw.use_callback(_capture, []); })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let _pipe = modal.open(component);
          let _pipe$1 = $promise.map(_pipe, next);
          return $promise.map(_pipe$1, dispatch);
        },
      );
    },
  );
}

function page_actions() {
  return $redraw.compose(
    $invite_users.invite_modal(),
    (invite_users) => {
      return $redraw.component_(
        "PageActions",
        (_) => {
          let store = $store.use_state();
          let org = $store.current_organization(store);
          let on_click = use_modal_click(invite_users, on_invite);
          let disabled = $option.is_none(org);
          return $button.primary(
            toList([$e.on_click(on_click), $a.disabled(disabled)]),
            toList([$h.text("Invite user")]),
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    $list_users.view(),
    (list_users) => {
      return $redraw.compose(
        $invite_users.view(),
        (invite_users) => {
          return $redraw.compose(
            page_actions(),
            (page_actions) => {
              return $redraw.component_(
                "Organization(ManageUsers)",
                (_use0) => {
                  let route = _use0[0];
                  return $l.column(
                    toList([$l.gap(12)]),
                    toList([]),
                    toList([
                      $common.page_title("Authentication"),
                      $l.row(
                        toList([$l.justify("space-between")]),
                        toList([]),
                        toList([
                          $tab_bar.tab_bar(
                            toList([
                              tab(new $route.ListUsers(), "Users"),
                              tab(new $route.InviteUsers(), "Invitations"),
                            ]),
                          ),
                          page_actions(undefined),
                        ]),
                      ),
                      (() => {
                        if (route instanceof $route.ListUsers) {
                          return list_users(undefined);
                        } else {
                          return invite_users(undefined);
                        }
                      })(),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
